import { MenuItem } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "src/constants";
import { fetchUsers, updateUserStatus } from "src/slices/users/thunk";
import { AppDispatch } from "src/store";

export const UsersTableActionMenu = ({ closeMenu, row }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>()

  const updatestatus = (row) => {
    dispatch(updateUserStatus({
      userId: row.original.id,
      isActive: !row.original.isActive
    })).then(()=>{
      dispatch(fetchUsers())
    })
  }

  return [
    <MenuItem
      key={1}
      onClick={() => {
        closeMenu();
        navigate(`${RoutePaths.CREATE_USER}/${row.original.id}`);
      }}
      sx={{ m: 0 }}
    >
      Update User
    </MenuItem>,
    <MenuItem
      key={2}
      onClick={() => {
        closeMenu();
        updatestatus(row);
      }}
      sx={{ m: 0 }}
    >
      {row.original.isActive ? 'Disable': 'Enable'}
    </MenuItem>,
  ];
};
